import { memo, useMemo } from 'react';
import HeaderSection, { HeaderSectionProps } from '../header-section';
import Rating from '../rating';

export interface HeaderStarProps {
  rating: number;
  ratingDescription: string;
  textGuide: string;
  headerSectionProps: HeaderSectionProps;
  sectionId?: string;
}

const HeaderStar: React.FC<HeaderStarProps> = ({
  rating,
  ratingDescription,
  textGuide,
  sectionId,
  headerSectionProps,
}) => {
  const { bgColor, textAlign } = headerSectionProps;
  const classNameMain = `bg-${bgColor} py-24 sm:py-32 text-${textAlign}`;

  const ratingAlign = {
    left: 'justify-start',
    center: 'justify-center',
    right: 'justify-end',
  };

  const classNameContainer = useMemo(() => {
    switch (textAlign) {
      case 'center':
        return `w-full lg:mx-0`;
      case 'right':
        return `mx-auto max-w-7xl lg:mx-0`;
      case 'left':
      default:
        return `mx-auto max-w-2xl lg:mx-0`;
    }
  }, [textAlign]);

  return (
    <div className={classNameMain} id={sectionId}>
      <div className="mx-auto max-w-7xl px-24 lg:px-32">
        <div className={classNameContainer}>
          <Rating rating={rating} ratingDescription={ratingDescription} className={ratingAlign[textAlign]} />
          <p className="pt-8 text-base font-medium text-padi-gray-darkest">{textGuide}</p>
        </div>
      </div>
      <HeaderSection {...headerSectionProps} className="pt-8" />
    </div>
  );
};

export default memo(HeaderStar);
